import CustomizePackageCallToAction from '@/components/CallToAction/CustomizePackageCallToAction';
import VerticalLeadFormSection from '@/components/LeadForm/VerticalLeadFormSection';
import FinancingPricingTable from '@/components/PricingTable/FinancingPricingTable';
import PackageFrequentlyAskedQuestions from '@/components/FrequentlyAskedQuestions/PackageFrequentlyAskedQuestions';
import OurBenefits from '@/components/FeatureSection/OurBenefits';
import AlternatingHighlights from '@/components/FeatureSection/AlternatingHighlights';
import ProductsLogoCloud from '@/components/LogoCloud/ProductsLogoCloud';
import MetaTags from '@/components/Head/MetaTags';

export default function Page() {
  return (
    <>
      <MetaTags
        title={`Compare Home Solar & Battery Systems - EnergyPal`}
        description={`Compare solar and battery systems at EnergyPal to find the best package for your home. We'll customize it to fit your energy needs.`}
      />
      <div className="bg-gray-100">
        <div className="px-4 py-16 mx-auto text-center max-w-7xl sm:py-24 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl sm:tracking-tight lg:text-5xl">
            Compare our solar &amp; battery systems
          </h1>
          <h2 className="mt-5 text-xl text-gray-500">
            Choose the EnergyPal package that works best for you, and then
            we&apos;ll customize it to fit your home.
          </h2>
        </div>
      </div>
      <FinancingPricingTable />
      <CustomizePackageCallToAction />
      <AlternatingHighlights />
      <ProductsLogoCloud />
      <OurBenefits />
      <VerticalLeadFormSection className="bg-white" />
      <PackageFrequentlyAskedQuestions />
    </>
  );
}
